/**
 * Fork Status Banner Component
 * Shows current fork/environment status (only when DEBUG_SHOW_URLS = true)
 */
import { useState } from 'react';
import { PRODUCTION_URL, EXPECTED_BACKEND } from '../../utils/api';

const ForkStatusBanner = () => {
  const [isVisible, setIsVisible] = useState(() => {
    // Prüfe ob Banner bereits geschlossen wurde (für diese Session)
    return sessionStorage.getItem('debug_banner_closed') !== 'true';
  });
  
  const backendUrl = process.env.REACT_APP_BACKEND_URL || 'NICHT GESETZT';
  const isProduction = backendUrl.includes('babelmix.com');
  
  // Zeige Banner nur wenn DEBUG_SHOW_URLS aktiviert ist
  if (!window.DEBUG_SHOW_URLS || !isVisible) return null;
  
  const handleManualRedirect = () => {
    if (window.FORK_GUARD?.redirectToProduction) {
      window.FORK_GUARD.redirectToProduction();
    } else {
      window.location.href = PRODUCTION_URL;
    }
  };
  
  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem('debug_banner_closed', 'true');
  };
  
  return (
    <div className={`fixed top-0 left-0 right-0 z-50 p-2 text-xs ${isProduction ? 'bg-green-500' : 'bg-amber-500'} text-white`}>
      <div className="flex items-center justify-between max-w-screen-xl mx-auto">
        <div className="flex-1 truncate">
          <strong>🔧 DEBUG</strong> | 
          {window.APP_VERSION} | 
          <span className="hidden sm:inline">Backend: </span>{backendUrl.replace('https://', '').substring(0, 35)}
        </div>
        <div className="flex items-center gap-2">
          {isProduction ? (
            <span className="hidden sm:inline">✅ Produktion</span>
          ) : (
            <>
              <span className="hidden sm:inline">⚠️ Preview</span>
              <button 
                onClick={handleManualRedirect}
                className="bg-white text-amber-600 px-2 py-1 rounded text-xs font-bold hover:bg-gray-100"
              >
                → babelmix.com
              </button>
            </>
          )}
          <button 
            onClick={handleClose}
            className="bg-white/20 hover:bg-white/30 px-2 py-1 rounded text-white font-bold"
            title="Debug-Banner schließen"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForkStatusBanner;
